module.exports = __webpack_public_path__ + "public/images/tab.bfb6f6b4f8eb5d764965c45c1a6f4d0f.svg";